"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Champagne = function Champagne(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "26px",
    height: "29px",
    viewBox: "0 0 26 29",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1202.000000, -2998.000000)",
    stroke: fill,
    strokeWidth: "2.5"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1203.000000, 3000.000000)"
  }, /*#__PURE__*/_react["default"].createElement("line", {
    x1: "0.305555556",
    y1: "23.2811111",
    x2: "6.44111111",
    y2: "25.1522222"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "3.37333333",
    y1: "24.2166667",
    x2: "5.24888889",
    y2: "18.0666667"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.91555556,18.0711111 L7.91555556,18.0711111 C6.16878046,18.6173555 4.26575273,18.0369651 3.12111111,16.6088889 L3.12111111,16.6088889 C2.04571335,15.2625987 1.80644866,13.4306615 2.5,11.8533333 L7.18222222,0.631111111 C7.34042979,0.248675028 7.7623935,0.0480142398 8.15888889,0.166666667 L12.9088889,1.61111111 C13.3051575,1.73548124 13.5425347,2.14007967 13.4577778,2.54666667 L11.0844444,14.4711111 C10.7789981,16.1666453 9.5586391,17.553028 7.91555556,18.0711111 Z"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "4.97666667",
    y1: "5.91777778",
    x2: "12.34",
    y2: "8.16333333"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.67888889,9.38555556 C6.78436336,9.41756919 6.87268184,9.49038548 6.92421681,9.58782204 C6.97575178,9.6852586 6.98623378,9.79924322 6.95333333,9.90444444 C6.88547027,10.1246141 6.65327412,10.2493762 6.43222222,10.1844444 C6.3270044,10.1524169 6.23888999,10.0797753 6.18738177,9.98259784 C6.13587355,9.88542038 6.12521951,9.77172148 6.15777778,9.66666667 C6.22564085,9.446497 6.45783699,9.32173489 6.67888889,9.38666667"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.8455556,9.38555556 C15.95103,9.41756919 16.0393485,9.49038548 16.0908835,9.58782204 C16.1424184,9.6852586 16.1529004,9.79924322 16.12,9.90444444 C16.0521369,10.1246141 15.8199408,10.2493762 15.5988889,10.1844444 C15.4934144,10.1524308 15.4050959,10.0796145 15.353561,9.98217796 C15.302026,9.8847414 15.291544,9.77075678 15.3244444,9.66555556 C15.3923075,9.44538589 15.6245037,9.32062378 15.8455556,9.38555556"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.3455556,11.8888889 C18.45103,11.9209025 18.5393485,11.9937188 18.5908835,12.0911554 C18.6424184,12.1885919 18.6529004,12.3025766 18.62,12.4077778 C18.5521369,12.6279474 18.3199408,12.7527095 18.0988889,12.6877778 C17.9934144,12.6557641 17.9050959,12.5829479 17.853561,12.4855113 C17.802026,12.3880747 17.791544,12.2740901 17.8244444,12.1688889 C17.8923075,11.9487192 18.1245037,11.8239571 18.3455556,11.8888889"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.6788889,14.3855556 C16.7843634,14.4175692 16.8726818,14.4903855 16.9242168,14.587822 C16.9757518,14.6852586 16.9862338,14.7992432 16.9533333,14.9044444 C16.8854703,15.1246141 16.6532741,15.2493762 16.4322222,15.1844444 C16.3267478,15.1524308 16.2384293,15.0796145 16.1868943,14.982178 C16.1353593,14.8847414 16.1248773,14.7707568 16.1577778,14.6655556 C16.2256408,14.4453859 16.457837,14.3206238 16.6788889,14.3855556"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.34555556,11.8888889 C8.45103003,11.9209025 8.53934851,11.9937188 8.59088348,12.0911554 C8.64241845,12.1885919 8.65290045,12.3025766 8.62,12.4077778 C8.55213693,12.6279474 8.31994079,12.7527095 8.09888889,12.6877778 C7.99341442,12.6557641 7.90509594,12.5829479 7.85356097,12.4855113 C7.802026,12.3880747 7.791544,12.2740901 7.82444444,12.1688889 C7.89230751,11.9487192 8.12450366,11.8239571 8.34555556,11.8888889"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.84555556,14.3855556 C5.95103003,14.4175692 6.03934851,14.4903855 6.09088348,14.587822 C6.14241845,14.6852586 6.15290045,14.7992432 6.12,14.9044444 C6.05213693,15.1246141 5.81994079,15.2493762 5.59888889,15.1844444 C5.49341442,15.1524308 5.40509594,15.0796145 5.35356097,14.982178 C5.302026,14.8847414 5.291544,14.7707568 5.32444444,14.6655556 C5.39230751,14.4453859 5.62450366,14.3206238 5.84555556,14.3855556"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "17.55",
    y1: "25.2011111",
    x2: "23.6944444",
    y2: "23.36"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "20.6222222",
    y1: "24.2811111",
    x2: "18.7766667",
    y2: "18.1211111"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.4022222,0.372222222 L16.0411111,0.181111111 C16.4396146,0.0650041392 16.8611792,0.270258492 17.0155556,0.655555556 L21.6433333,11.8966667 C22.3288362,13.4771859 22.0810545,15.3075178 21,16.6488889 L21,16.6488889 C19.848593,18.0720751 17.9432476,18.6451776 16.1977778,18.0933333 L16.1977778,18.0933333 C15.1178933,17.7497993 14.2027665,17.0198343 13.6277778,16.0433333"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "16.2277778",
    y1: "6.83777778",
    x2: "19.1955556",
    y2: "5.94888889"
  })))));
};
Champagne.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Champagne.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Champagne;